import { useAppMessages } from 'hooks/useAppMessages';
import { useIntl } from 'react-intl';
import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';
import {
  FindInventoryLocationBuildingArgs,
  FindInventoryLocationBuildingResponse,
} from 'services/api/inventoryLocationBuildings';
import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';
import { InventoryLocationBuildings as messages } from '../../messages';

interface UseInventoryLocationBuildings {
  filter?: FindInventoryLocationBuildingArgs['filter'];
  populate?: FindInventoryLocationBuildingArgs['populate'];
  errorMessage?: string;
  onSuccess?: (data: FindInventoryLocationBuildingResponse['data']) => void;
}

export const useInventoryLocationBuildings = (
  { filter, populate, errorMessage, onSuccess }: UseInventoryLocationBuildings = {},
  { enabled = true }: UseQueryOptions = {},
): UseQueryResult<FindInventoryLocationBuildingResponse> => {
  const intl = useIntl();
  const appMessages = useAppMessages();
  const {
    api: { inventoryLocationBuildingsApiClient },
  } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.inventoryLocationBuildings.filter(filter),
    queryFn: async ({ signal }) => await inventoryLocationBuildingsApiClient.find({ filter, populate, signal }),
    enabled,
    onError: () => appMessages.error(errorMessage ?? intl.formatMessage(messages.noBuildingsFound)),
    onSuccess: ({ data }) => onSuccess?.(data),
  });
};
